import React from 'react'
// @src imports
import { Icon } from 'src/chrome'
import { ItemCategoryFragment } from 'src/graphql'

import styles from './ribbon.module.scss'

type Props = {
  items?: ItemCategoryFragment[]
  isWrapContentEnabled?: boolean
  isScrollBarEnabled?: boolean
  onItemCategoryClick?: (category: ItemCategoryFragment) => void
  isSeeAllButtonEnabled: boolean
  title?: string
}

const TileRibbon: React.FC<Props> = props => {
  const {
    items,
    isWrapContentEnabled,
    isScrollBarEnabled,
    onItemCategoryClick,
    isSeeAllButtonEnabled,
    title,
  } = props
  return (
    <div className={styles.ribbon} style={{ padding: 0 }}>
      <div className={styles.ribbonInfo}>
        {title && <h5 style={{ cursor: 'pointer' }}>{title}</h5>}
        {isSeeAllButtonEnabled && !isWrapContentEnabled && (
          <h6 className={styles.more}>
            SEE ALL <Icon icon={'CARROTRIGHT'} size={12} color={''} />
          </h6>
        )}
      </div>
      <div
        className={styles.itemContainer}
        style={{
          ...(isWrapContentEnabled && {
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }),
          ...(!isScrollBarEnabled && { overflowX: 'hidden' }),
        }}
      >
        {items &&
          items.map((category, index) => {
            const backgroundType = {
              backgroundImage: `url(${category.backgroundImageUrl})`,
            }
            return (
              <div
                id={`item_${index}`}
                className={styles.tile}
                style={backgroundType}
                key={category.id}
                onClick={() => onItemCategoryClick?.(category)}
              >
                <span>{category.name}</span>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default TileRibbon
